import i18n from './plugins/i18n'

//  Global
// eslint-disable-next-line
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

// eslint-disable-next-line
Array.prototype.binarySearch = function (key, value) {
    if (this.length === 0) return undefined
    let i = 0
    let j = this.length - 1
    while (i <= j) {
        let m = Math.floor((i + j) / 2)
        let keyVal = key(this[m])
        if (keyVal === value) {
            return this[m]
        } else if (keyVal < value) {
            i = m + 1
        } else {
            j = m - 1
        }
    }
    return undefined
}

const utils = {
    formatPhone (number, type = 'phone') {
        //  Formatta un numero di telefono con spazi
        if (number) {
            if (type === 'phone') return number.replace(/(\d{4})(\d{6})/, '$1 $2')
            if (type === 'mobile') return '+' + number.replace(/(\d{2})(\d{3})(\d{3})(\d{4})/, '$1 $2 $3 $4')
        } else {
            return '-'
        }
    },
    formatAddress (nazione, regione, provincia, comune, cap, frazione, via, numCivico) {
        return via + ' ' + numCivico + ', ' + cap + ' ' + frazione + ' ' + comune + ' (' + provincia + '), ' + nazione
    },
    getLocale () {
        return navigator.language.substring(0, 2)
    },
    getMarkerColor (seed) {
        return ['#FFAB00', '#AEEA00', '#CF432C', '#00BFA5', '#6200EA', '#C51162', '#AA00FF', '#00B8D4', '#64DD17', '#0091EA', '#FF6D00', '#FFD600', '#304FFE', '#00C853'
        ][seed % 28]
    },
    time: {
        toSeconds (stringVal) {
            let a = stringVal.split(':')
            return (+a[0]) * 60 * 60 + (+a[1]) * 60
        },
        toString (totalSeconds) {
            let hours = Math.floor(totalSeconds / 3600)
            totalSeconds -= hours * 3600
            let minutes = Math.floor(totalSeconds / 60)
            let str = minutes + ' ' + i18n.t('label.minuti')
            if (hours > 0) str = hours + ' ' + i18n.t('label.ore') + ' ' + str
            return str
        }
    },
    date: {
        toSql (jsDate) {
            let month = '' + (jsDate.getMonth() + 1)
            let day = '' + jsDate.getDate()
            let year = jsDate.getFullYear()
            if (month.length < 2) {
                month = '0' + month
            }
            if (day.length < 2) {
                day = '0' + day
            }
            return [year, month, day].join('-')
        },
        toJs (sqlDate) {
            return new Date(sqlDate)
        },
        getSqlToday () {
            return utils.date.toSql(new Date())
        },
        getSqlCurrentMonth () {
            return utils.date.getSqlToday().slice(0, -3)
        },
        getJsToday () {
            return new Date()
        },
        addDays (jsDate, daysNumber) {
            let date = new Date(jsDate)
            date.setDate(date.getDate() + daysNumber)
            return date
        },
        getMonths () {
            let result = []
            for (let i = 0; i < 12; i++) {
                let m = new Date()
                m.setMonth(i)
                result.push(i18n.d(m, 'monthName').capitalize())
            }
            return result
        },
        reverseDayMonth (date) {
            var dateTemp = date.split("/");
            var month = dateTemp[1];
            var day = dateTemp[0];
            var year = dateTemp[2];

            var dateReverse = month + "/" + day + "/" + year;

            return dateReverse;
        }
    },
    rules: {
        required: v => !!v || i18n.t('errori.campo_richiesto'),
        email: v => !v || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || i18n.t('errori.email'),
        sdi: v => !v || v.length === 7 || i18n.t('errori.sdi'),
        telephone: v => !v || v.length >= 9 || i18n.t('errori.telefono'),
        targa: v => /^[A-Z]{2}[0-9]{3}[A-Z]{2}$/.test(v) || i18n.t('errori.targa'),
        password: [
            v => !v || v.length >= 8 || i18n.t('errori.password_minimo'),
            v => !v || /[0-9]+/.test(v) || i18n.t('errori.password_numero'),
            v => !v || /[a-z]+/.test(v) || i18n.t('errori.password_minusc'),
            v => !v || /[A-Z]+/.test(v) || i18n.t('errori.password_maiusc'),
            v => !v || /\W+/.test(v) || i18n.t('errori.password_simbolo')
        ],
        cuaa: v => {
            if (utils.rules.partitaIVA(v) === true) return true
            if (utils.rules.cf(v) === true) return true
            return i18n.t('errori.cuaa')
        },
        cf: v => !v || /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/.test(v) || i18n.t('errori.cf'),
        partitaIVA: v => {
            if (!v) return true
            if (!/^[0-9]{11}$/.test(v)) return i18n.t('errori.partita_iva_cifre')
            let s = 0
            for (let i = 0; i <= 9; i += 2) {
                s += v.charCodeAt(i) - 48
            }
            for (let i = 1; i <= 9; i += 2) {
                let c = 2 * (v.charCodeAt(i) - 48)
                if (c > 9) c = c - 9
                s += c
            }
            let atteso = (10 - (s % 10)) % 10
            return atteso === v.charCodeAt(10) - 48 || i18n.t('errori.partita_iva_codice')
        }
    }
}

export default utils
